module.exports = __webpack_public_path__ + "static/img/vivo2.0fa77b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/vivo/vivo2.png
// module id = u2bM
// module chunks = 0